import "./nav.css";
import resume from "../../images/kyleResume.pdf";

function Nav({ dummy, nav, ab, pr, sk, hr }) {
  return (
    <>
      <div className="dummy" ref={dummy} ></div>
      <nav ref={nav}>
        <div className="ln1">
          <a href="/#home">
            <h2>Kyle Huang</h2>
          </a>
        </div>
        <div className="ln2">
          <ul className="navlinks">
            <li>
              <a ref={hr} href="/#home">
                Home
              </a>
            </li>
            <li>
              <a ref={ab} href="/#about">
                About
              </a>
            </li>
            <li>
              <a ref={pr} href="/#projects">
                Projects
              </a>
            </li>
            <li>
              <a ref={sk} href="/#skills">
                Skills
              </a>
            </li>
            <li>
              <a href={resume}>Resume</a>
            </li>
            <a href="/#contact">
              <button className="btnGreen">Contact</button>
            </a>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Nav;
